import styled, { css } from 'styled-components';
import { layout } from 'styled-system';
import { colors } from '@keen.io/colors';
import Card from '../Card';
export var SmallItem = styled.div.withConfig({
  displayName: "FunnelStepstyles__SmallItem",
  componentId: "keen-query-creator__sc-2fbca5-0"
})(["&&&{display:flex;justify-content:space-between;width:140px;padding-top:20px;}&&& label > div{margin-right:10px;}"]);
export var Item = styled.div.withConfig({
  displayName: "FunnelStepstyles__Item",
  componentId: "keen-query-creator__sc-2fbca5-1"
})(["&&&{flex:1;max-width:320px;min-width:285px;}"]);
export var Wrapper = styled.div.withConfig({
  displayName: "FunnelStepstyles__Wrapper",
  componentId: "keen-query-creator__sc-2fbca5-2"
})(["&&&{display:flex;flex-wrap:wrap;align-items:center;padding:10px 0 20px 0;grid-gap:20px;", ";}"], layout);
export var CardWrapper = styled(Card).withConfig({
  displayName: "FunnelStepstyles__CardWrapper",
  componentId: "keen-query-creator__sc-2fbca5-3"
})(["&&& ", " + ", "{border-top:1px solid ", ";}"], Wrapper, Wrapper, colors.white[300]);
export var StepContainer = styled.div.withConfig({
  displayName: "FunnelStepstyles__StepContainer",
  componentId: "keen-query-creator__sc-2fbca5-4"
})(["&&&{cursor:", ";}&&& ", " + ", "{border-top:1px solid ", ";}"], function (props) {
  return props.isDragged ? 'grabbing' : 'grab';
}, CardWrapper, CardWrapper, colors.white[300]);
export var StepHeader = styled.div.withConfig({
  displayName: "FunnelStepstyles__StepHeader",
  componentId: "keen-query-creator__sc-2fbca5-5"
})(["&&&{display:flex;flex-direction:row;align-items:center;font-size:14px;font-family:Lato Bold,sans-serif;}"]);
export var StepTitle = styled.div.withConfig({
  displayName: "FunnelStepstyles__StepTitle",
  componentId: "keen-query-creator__sc-2fbca5-6"
})(["&&&{color:", ";", ";}"], colors.black[100], function (props) {
  return props.hasError && css(["color:", ";"], colors.red[500]);
});
export var IconContainer = styled(StepHeader).withConfig({
  displayName: "FunnelStepstyles__IconContainer",
  componentId: "keen-query-creator__sc-2fbca5-7"
})(["&&&{margin-right:10px;}"]);
export var Settings = styled(StepHeader).withConfig({
  displayName: "FunnelStepstyles__Settings",
  componentId: "keen-query-creator__sc-2fbca5-8"
})(["&&&{margin-left:auto;}"]);
export var HintHighlight = styled.div.withConfig({
  displayName: "FunnelStepstyles__HintHighlight",
  componentId: "keen-query-creator__sc-2fbca5-9"
})(["&&&{margin-top:15px;font-family:Lato Bold,sans-serif;}"]);
export var Clone = styled(StepHeader).withConfig({
  displayName: "FunnelStepstyles__Clone",
  componentId: "keen-query-creator__sc-2fbca5-10"
})(["&&&{color:", ";font-family:Lato Bold,sans-serif;font-size:14px;cursor:pointer;}"], colors.blue[100]);
export var Close = styled(StepHeader).withConfig({
  displayName: "FunnelStepstyles__Close",
  componentId: "keen-query-creator__sc-2fbca5-11"
})(["&&&{margin-left:21px;cursor:pointer;}"]);
export var StepName = styled.span.withConfig({
  displayName: "FunnelStepstyles__StepName",
  componentId: "keen-query-creator__sc-2fbca5-12"
})(["&&&{margin-left:10px;color:", ";font-family:Lato Medium,sans-serif;font-size:14px;}"], colors.blue[500]);
export var Incomplete = styled.span.withConfig({
  displayName: "FunnelStepstyles__Incomplete",
  componentId: "keen-query-creator__sc-2fbca5-13"
})(["&&&{color:", ";font-size:14px;font-family:Lato Semibold,sans-serif;margin-left:10px;}"], colors.red[200]);